import React from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";

import ComponentContainer from "../../layouts/component-container";
import Anchor from "../../atoms/Anchor";
import CustomSlider from "../../atoms/CustomSlider";
import DesktopTicker from "./DesktopTicker";

import { staticTexts } from "../../utils/Translate";
import { getHeadline } from "../../utils/utils";
import { useDevice } from "../../utils/react-utils";

import "./newsHeadlineTicker.m.css";

const NewsHeadlineTicker = ({ collection, lang }) => {
  const { mobile } = useDevice();

  if (!collection?.items?.length) return null;

  const {
    items,
    "associated-metadata": {
      number_of_stories_to_show: storiesToShow = 10,
      enable_auto_play: autoplay = false,
      navigate_to_title: navigateToTitle,
    },
  } = collection;

  const stories = items.reduce((accumulator, item) => {
    if (item.type === "story") {
      accumulator.push(item.story);
    }
    return accumulator;
  }, []);

  if (!stories.length) return null;

  const storyList = stories.slice(0, storiesToShow);

  return (
    <ComponentContainer collection={collection} isTitle={false} styleName="base">
      <div styleName={`wrapper ${autoplay ? "ticker-auto-slide" : ""}`} id="wrapper">
        <h3 styleName="headline" id="headline">
          {navigateToTitle || `${staticTexts(lang).tickerHeadline}${mobile !== undefined && !mobile ? ":" : ""}`}
        </h3>
        {mobile !== undefined &&
          (mobile ? (
            <CustomSlider
              isAutoplay={autoplay}
              isPagination={false}
              spacing={{ mobileSpace: 8, tabSpace: 0 }}
              slidesPerView={{ mobileSlides: 1.2, tabSlides: 2.2, desktopSlides: 4.4 }}
              isNoPaddingMobile={false}
              isNavigation={false}
              showPlayPauseBtn={false}
            >
              {storyList.map((story, index) => (
                <Anchor
                  key={index}
                  aria-label={story.headline}
                  href={story.url}
                  styleName="item mobile-ticker"
                  className="ticker-item"
                >
                  {getHeadline(story)}
                </Anchor>
              ))}
            </CustomSlider>
          ) : (
            <DesktopTicker storyList={storyList} />
          ))}
      </div>
    </ComponentContainer>
  );
};

NewsHeadlineTicker.propTypes = {
  collection: object.isRequired,
  lang: string,
};

NewsHeadlineTicker.storyLimit = 15;

const mapStateToProps = (state) => ({
  lang: state.qt.config["publisher-attributes"].lang || "bn",
});

export default connect(mapStateToProps)(NewsHeadlineTicker);
